import qs from 'qs'
import axios from '../config/axios.js'
import { getApiUrl } from '../config/baseUrl.js'
let config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } };
let configV1 = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } };
const BASE_URL = getApiUrl('/api/college_manage')
const BASE_URL_V2 = getApiUrl('/api/spark-collage-web')
export const UserServer = {
  login: (params) => {
    return axios.post(`${BASE_URL}/auth/login`, qs.stringify(params)).then(res => res.data)
  }
}
export const keyServer = {
  profession: (params) => {
    return axios.get(`${BASE_URL}/sysDictionary/getByKey`, {params: params}, config).then(res => res.data)
  }
}
export const courseServer = {
  courseDirectoryList: (params) => {
    return axios.get(`${BASE_URL}/courseDirectory/query`, {params: params}, config).then(res => res.data)
  },
  courseDirectoryAdd: (params) => {
    return axios.post(`${BASE_URL}/courseDirectory/add`, qs.stringify(params), config).then(res => res.data)
  },
  courseDirectoryUpdate: (params) => {
    return axios.post(`${BASE_URL}/courseDirectory/update`, qs.stringify(params), config).then(res => res.data)
  },
  courseDirectoryRemove: (params) => {
    return axios.post(`${BASE_URL}/courseDirectory/remove`, qs.stringify(params), config).then(res => res.data)
  },
  courseBatchUpdate: (params) => {
    return axios.post(`${BASE_URL}/courseDirectory/batchUpdate`, params, configV1).then(res => res.data)
  },
  courseDirectorySet: (params) => {
    return axios.post(`${BASE_URL}/courseDirectory/setTask`, qs.stringify(params), config).then(res => res.data)
  },
  courseDirectoryBatchSet: (params) => {
    return axios.post(`${BASE_URL}/courseDirectory/batch/setTask`, qs.stringify(params), config).then(res => res.data)
  },
  profressionDirectory: (params) => {
    return axios.get(`${BASE_URL}/profession/queryProfressionDirectory`, {params: params}, config).then(res => res.data)
  },
  configDirectory: (params) => {
    return axios.post(`${BASE_URL}/profession/configDirectory`, qs.stringify(params), config).then(res => res.data)
  },
}
export const rptTemplateServer = {
  getTemplete: (params) => {
    return axios.get(`${BASE_URL_V2}/rptTemplate/query`, {params: params}).then(res => res.data)
  },
  saveTemplete: (params) => {
    return axios.post(`${BASE_URL_V2}/rptTemplate/save`, qs.stringify(params), config).then(res => res.data)
  },
  deleteTemplete: (params) => {
    return axios.get(`${BASE_URL_V2}/rptTemplate/delete`, {params: params}).then(res => res.data)
  },
  deleteTempleteByModality: (params) => {
    return axios.get(`${BASE_URL_V2}/rptTemplate/deleteByModality`, {params: params}).then(res => res.data)
  },
  exportTemplete: (params) => {
    return axios.get(`${BASE_URL_V2}/rptTemplate/exportExcel`, {params: params, responseType: 'blob'}).then(res => res.data)
  },
  importExcel: (params) => {
    return axios.post(`${BASE_URL_V2}/rptTemplate/importExcel`, qs.stringify(params)).then(res => res.data)
  },
}



// WEBPACK FOOTER //
// ./src/api/server/system.js